/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricsForRecommendation {
    getFixupPrototypeFunction() { return UtilizationMetricsForRecommendation.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricsForRecommendation>): UtilizationMetricsForRecommendation {
        let obj = Object.assign(new UtilizationMetricsForRecommendation(), model);
        UtilizationMetricsForRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricsForRecommendation>): UtilizationMetricsForRecommendation {
        if (!model) return null;
        return UtilizationMetricsForRecommendation.newInstance(<UtilizationMetricsForRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricsForRecommendation) {
        if (!obj) return;

        models.UtilizationMetricsForRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricsForRecommendation): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricsForRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.start_date === undefined) {
            this.start_date = 0;
        }
        if (this.end_date === undefined) {
            this.end_date = 0;
        }
        if (this.granularity === undefined) {
            this.granularity = 0;
        }
    }

    /**
     * specify the start date in epoch time stamp.
     */
    start_date: number;

    /**
     * specify the end date in epoch time stamp.
     */
    end_date: number;

    /**
     * Granularity at which the utilization metric is being persisted.
     */
    granularity: number;

    /**
     * Metric name
     */
    metric_name: string;

    /**
     * values for the metrics
     */
    values: Array<number>;

}
